exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-number-input{padding:6px;width:108px}.page-number-input::-moz-placeholder{color:var(--gray-6)}.page-number-input:-ms-input-placeholder{color:var(--gray-6)}.page-number-input::placeholder{color:var(--gray-6)}", ""]);

// exports
